import React, { useContext, useState, useRef, useMemo } from 'react'
/** @jsx jsx */
import { jsx } from '@emotion/core'
import { connect } from 'react-redux'
import moment from 'moment'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { numCol, strCol } from '@integec/grid-tools/lib/cols'
import { Button, DatePicker, Upload, Input, Icon, message } from 'antd'
import {
  gethydroEvents,
  savehydroEvents,
  getAuthorization,
  getCredentials,
  hydroUnitLockStatus,
  hydroReImport,
} from 'api/pgads'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import {
  getEnvConfig,
  getPermitActions,
  ExportComponent,
  getApiTargetInfo,
} from 'core'
import UtilityUnitSelector from 'core/component/UtilityUnitSelection'
import {
  modifiedDateCol,
  modifierCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import { getUnitNameMap, getUnits, getUtilityNameMap } from 'core/selectors'
import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
} from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import HydroInsertModal from './HydroInsertEventModal'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import JcTmpErrorContext from 'context/JcTmpErrorContext'
import * as R from 'ramda'
import HydroImportConfromModal from './HydroImportConformModal'
const HydroEvents = ({
  apiTargetInfo,
  utilityNameMap,
  unitNameMap,
  units,
  envConfig,
  actionPermits,
}) => {
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [selUnit, setSelUnit] = useState([])
  const [data, setData] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [showInsertModal, setShowInsertModal] = useState(false)
  const [unitLockMap, setUnitLockMap] = useState({})

  const { setTmpError } = useContext(JcTmpErrorContext)

  const [showImportModal, setShowImportModal] = useState(false)
  const [importResponse, setImportResponse] = useState({})

  // useEffect(
  //   _ => {
  //     const { errors = [], dataExits = 0 } = importResponse
  //     if (parseFloat(dataExits) > 0) {
  //       setShowImportModal(true)
  //     } else {
  //       if (errors.length > 0) setTmpError(errors)
  //       message.success('File imported successfully')
  //     }
  //   },
  //   [importResponse, setTmpError]
  // )

  const dataReimport = allowReimport => {
    setShowImportModal(false)
    if (allowReimport) {
      hydroReImport(apiTargetInfo)(importResponse.data || []).fork(
        setError,
        data => {
          setImportResponse(data)
          const { errors = [], dataExits = 0 } = data
          if (parseFloat(dataExits) > 0) {
            setShowImportModal(true)
          } else {
            if (errors.length > 0) setTmpError(errors)
            message.success('File imported successfully')
          }
        }
      )
    }
  }

  const retrieve = ({ date = selectedDate, selUnits = selUnit[1] }) => {
    if (selUnits === undefined || selUnits.length < 1) {
      message.error('Please, Select Unit')
      return
    }
    setSpinning(true)

    hydroUnitLockStatus(apiTargetInfo)({
      date: date.format('YYYY-MM-DD'),
      units: [selUnits],
    }).fork(setError, setUnitLockMap)

    gethydroEvents(apiTargetInfo)({
      transDate: date.format('YYYY-MM-DD'),
      unitIds: [selUnits],
    }).fork(setError, data => {
      setSpinning(false)
      let ndata = data.map(d => ({
        ...d,
        utility: `${d.utility}-${utilityNameMap[d.utility]}`,
        unitId: `${d.unit}-${unitNameMap[d.unitId]}`,
        zoneDateStringZone: d.zoneDateString + d.zone,
        dt: moment(d.transDate),
      }))
      ndata = R.sort((a, b) => a.dt - b.dt, ndata)
      setData(ndata)
    })
  }
  const headerWithFormatter = headers.map(header => {
    if (header.ident === 'utility') {
      return {
        ...header,
        rowHeaderBackgroundColor: '#eee',
        sortIndexGetter: ({ rowData }) =>
          `${rowData.utility}-${utilityNameMap[rowData.utility]}` ||
          rowData.utility,
      }
    }
    if (header.ident === 'unitId') {
      return {
        ...header,
        rowHeaderBackgroundColor: '#eee',
        sortIndexGetter: ({ rowData }) =>
          `${rowData.utility}-${unitNameMap[rowData.unit]}` || rowData.unit,
      }
    }
    return header
  })
  const unitInfo = units.find(u => u.unitId === selUnit[1])

  const { authGodMode } = envConfig

  const fileProps = {
    name: 'file',
    action: `${apiTargetInfo.baseUrl}/hydro/import`,
    method: 'POST',
    headers: getAuthorization(apiTargetInfo),
    ...getCredentials(apiTargetInfo),
  }

  const GridRef = useRef()

  const openInsertModal = _ => {
    const lockStatus = unitLockMap[selUnit[1]] || 'U'
    if (lockStatus === 'U') setShowInsertModal(true)
    else message.error('You do not have access to edit this unit')
  }

  const generationOptionEndChange = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.HYDRO_NONHYDRO_OPTION_CHANGE],
    matchAny: true,
  })

  const hydroHideElevation = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.HYDRO_HIDE_ELEVATION],
    matchAny: true,
  })

  const hydroHidePump = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.HYDRO_HIDE_PUMP],
    matchAny: true,
  })

  const hydroHideSync = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.HYDRO_HIDE_SYNC],
    matchAny: true,
  })
  const nonHydroAllUnits = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.NON_HYDRO_ALL_UNITS],
    matchAny: true,
  })
  const renameHydroToBreakerEvent = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.RENAME_HYDRO_TO_BREAKER_EVENT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      {showImportModal && (
        <HydroImportConfromModal
          visible={showImportModal}
          onOk={dataReimport}
          importResponse={importResponse}
        />
      )}
      {showInsertModal && (
        <HydroInsertModal
          generationOptionEndChange={generationOptionEndChange}
          hydroHideElevation={hydroHideElevation}
          hydroHidePump={hydroHidePump}
          hydroHideSync={hydroHideSync}
          apiTargetInfo={apiTargetInfo}
          utility={unitInfo.utility}
          unit={unitInfo.unit}
          unitId={unitInfo.unitID}
          unitName={unitNameMap[selUnit[1]]}
          unitZone={unitInfo.timeZone}
          unitDlsEnabled={unitInfo.daylightSavings}
          visible={showInsertModal}
          renameHydroToBreakerEvent={renameHydroToBreakerEvent}
          date={selectedDate.format('YYYY-MM-DD')}
          onOk={data => {
            setSpinning(true)
            savehydroEvents(apiTargetInfo)(data).fork(
              setError,
              errorInfoList => {
                setSpinning(false)
                if (isErrorContains(errorInfoList)) {
                  setTmpError(errorInfoList || [])
                } else {
                  setShowInsertModal(false)
                  retrieve({})
                }
              }
            )
          }}
          onCancel={_ => setShowInsertModal(false)}
          spinning={spinning}
        />
      )}
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '200px',
          }}
        >
          {renameHydroToBreakerEvent ? 'Breaker Events' : 'Hydro Events'}
        </Title>

        <UtilityUnitSelector
          utility={selUnit[0]}
          unit={selUnit[1]}
          onUnitChange={setSelUnit}
          style={{ width: '500px' }}
          unitfilter={un =>
            nonHydroAllUnits || un.id1 === 'HD' || un.id1 === 'PS'
          }
        />

        <DatePicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            if (d && d.isValid) {
              setSelectedDate(d)
              retrieve({ date: d })
            }
          }}
        />

        <Button
          icon="database"
          loading={spinning}
          onClick={retrieve}
          css={{ marginLeft: '10px' }}
          disabled={
            !hasAccesPermits({
              authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.HYDRO_VIEW],
              matchAny: true,
            })
          }
          type="primary"
        >
          Retrieve
        </Button>
        <Button
          css={{ marginLeft: '10px' }}
          onClick={_ => {
            if (selUnit.length < 1) {
              message.error('Please,Select Unit')
              return
            }
            openInsertModal()
          }}
          icon="edit"
          disabled={
            !selUnit.length ||
            !hasAccesPermits({
              authGodMode,
              actionPermits,
              eventActions: [ScreenPermissions.HYDRO_ADD_DATA],
              matchAny: true,
            })
          }
        >
          Edit/Insert Events
        </Button>
        <Filler />
        <Upload
          {...fileProps}
          onChange={data => {
            // if (data.file.response && data.file.response.length) {
            //   setTmpError(data.file.response)
            // } else {
            //   if (data.file.response) {
            //     message.success('File imported successfully')
            //   }
            // }

            if (data.file.status === 'done') {
              // setImportResponse(data.file.response)
              const { errors = [], dataExits = 0 } = data.file.response
              if (parseFloat(dataExits) > 0) {
                setShowImportModal(true)
              } else {
                if (errors.length > 0) setTmpError(errors)
                message.success('File imported successfully')
              }
            }
          }}
          multiple={false}
          showUploadList={false}
        >
          <Button
            disabled={
              !hasAccesPermits({
                authGodMode,
                actionPermits,
                eventActions: [ScreenPermissions.HYDRO_IMPORT],
                matchAny: true,
              })
            }
            style={{ marginLeft: '5px' }}
          >
            <Icon type="upload" /> Import
          </Button>
        </Upload>
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <ExportComponent
          getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
          data={data}
          headers={exportHeaders}
          fileName={`Hydro Events ${moment().format('YYYY-MM-DD HH mm ss')}`}
          btnStyle={{ marginRight: '10px' }}
          disabled={!!(data && data.length <= 0)}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={220}>
        {({ height, width }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <Grid
              ref={GridRef}
              fuzzyFilter={fuzzyFilter}
              sortEnabled={false}
              data={data}
              headers={headerWithFormatter}
              altBy={u => u.unitId}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: false,
                rowHeaderRender,
                height: height - 50,
                width: width - 100,
                headerRowHeight: 30,
              })}
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const headers = [
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'zoneDateString',
    display: 'Transdate',
    width: 200,
    isFiltered: true,
  }),
  strCol({ ident: 'zone', display: 'Zone', width: 70, isFiltered: true }),
  strCol({
    ident: 'status',
    display: 'Status',
    width: 150,
    isFiltered: true,
  }),
  numCol({
    ident: 'elevation',
    display: 'Elevation',
    width: 150,
    isFiltered: true,
  }),
  strCol({
    ident: 'riverReservoir',
    display: 'River Reservoir',
    width: 150,
    isFiltered: true,
  }),

  modifierCol,
  modifiedDateCol,
]

const exportHeaders = [
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'zoneDateStringZone',
    display: 'Transdate',
    width: 200,
    isFiltered: true,
  }),
  strCol({
    ident: 'status',
    display: 'Status',
    width: 150,
    isFiltered: true,
  }),
  numCol({
    ident: 'elevation',
    display: 'Elevation',
    width: 150,
    isFiltered: true,
  }),
  strCol({
    ident: 'riverReservoir',
    display: 'River Reservoir',
    width: 150,
    isFiltered: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  units: getUnits(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})
export default connect(mapStateToProps)(HydroEvents)
